import gsap from "gsap";

import { ScrollTrigger } from "gsap/all";
import { useEffect } from "react";
gsap.registerPlugin(ScrollTrigger);

export default function PluginScale() {
  useEffect(() => {
    const triggerScale = document.querySelector(".brands-scale-wrapper");

    const brandsTl = gsap.timeline({
      scrollTrigger: {
        trigger: triggerScale,
        start: "center center",
        end: "bottom center",
        // markers: true,
        scrub: 1,
      },
    });

    brandsTl.to(".scale-wrapper-section", {
      rotate: "3.61deg",
      duration: 1,
    });
  }, []);

  return (
    <>
      <div className="brands-scale-wrapper">
        <section id="scale_section">
          <div className="scale-wrapper-section">
            <div className="container">
              <div className="scale-items-w">
                <span>Plug In</span>
                <div className="scale-item-shape">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="7.97168"
                      y="0.58252"
                      width="10.6743"
                      height="10.6743"
                      transform="rotate(45 7.97168 0.58252)"
                      fill="#8ABEAC"
                    />
                  </svg>
                </div>
                <span>Scale Up</span>
                <div className="scale-item-shape">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="7.97168"
                      y="0.58252"
                      width="10.6743"
                      height="10.6743"
                      transform="rotate(45 7.97168 0.58252)"
                      fill="#FEBF88"
                    />
                  </svg>
                </div>
                <span>Refine</span>
                <div className="scale-item-shape">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="7.97168"
                      y="0.58252"
                      width="10.6743"
                      height="10.6743"
                      transform="rotate(45 7.97168 0.58252)"
                      fill="#DA716A"
                    />
                  </svg>
                </div>
                <span>Repeat</span>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
